import React from 'react'
import { Checkbox } from 'react-bootstrap'

const rfCheckbox = ({
  input,
  disabled,
  label,
  required,
  meta: { touched, error },
  checked
}) => {
  return (
  <Checkbox
    style={{
      color: checked ? 'black' : 'grey'
    }}
    required={required}
    disabled={disabled}
    checked={checked}
    onChange={(e)=>input.onChange(e)}
  >
    {label}
  </Checkbox>
)}

export default rfCheckbox



// WEBPACK FOOTER //
// ./src/lib/themes/lingk/rfCheckbox.js